import React from 'react'
import { Tooltip } from '@surecompanies/core_components'
import { ExportOutlined } from '@ant-design/icons'

import { getApplicationDetailsPath } from 'modules/qle/utils/qleCommonLinks'

import { OPEN_IN_APP_ENGINE_LABEL } from '../recon-v2-helpers'
import styles from './ReviewQueue.module.scss'

/**
 * Open this row's benefit in its own application page — the queue's version of
 * the control the Benefits tab carries in its Insured cell and the Adjust
 * drawer carries in its id rail. All three go through
 * `getApplicationDetailsPath`, so the placements cannot drift.
 *
 * An anchor, not a button, and deliberately not `openApplicationDetails`
 * (`ApplicationsListContainer.tsx`) even though Payment assignment reaches the
 * same page through it: that helper opens a NAMED window, `appWindow`, so from
 * a table where an operator walks several rows each click would hijack the one
 * popup and lose the page before it. A plain new-tab anchor also gives
 * middle-click and "open in new tab" back, matching how the rest of
 * reconciliation links out.
 *
 * Not gated on write access: opening a page is a read. Same reason
 * {@link JumpToBenefitButton} is ungated.
 *
 * The caller supplies the guard, because only the caller knows whether it has
 * an id — a discrepancy always does, an unposted transaction may not.
 */
const OpenInAppEngineLink: React.FC<{ benefitId: string }> = ({
  benefitId,
}) => (
  <Tooltip title={OPEN_IN_APP_ENGINE_LABEL}>
    <a
      className={`${styles.copyButton} ${styles.copyLink}`}
      href={getApplicationDetailsPath(benefitId)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={OPEN_IN_APP_ENGINE_LABEL}
    >
      <ExportOutlined />
    </a>
  </Tooltip>
)

export default OpenInAppEngineLink
